export default "__VITE_ASSET__DWWMtC_1__"